import { SystemUser } from '@/rtk-query.gql';

export enum AuthenticationActions {
  UPDATE_ME = 'authentication/UPDATE_ME',
  LOGOUT = 'authentication/LOGOUT',
  UPDATE_IS_CSR = 'authentication/UPDATE_IS_CSR',
}

export type AuthenticationType = {
  me: SystemUser | null;
  isAuthenticated: boolean;
  isCsr: boolean;
};

export const initialState: AuthenticationType = {
  me: null,
  isAuthenticated: false,
  isCsr: false,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case AuthenticationActions.UPDATE_ME: {
      return {
        ...state,
        me: action.me,
        isAuthenticated: true,
      };
    }
    case AuthenticationActions.LOGOUT: {
      return {
        ...state,
        me: null,
        isAuthenticated: false,
      };
    }
    case AuthenticationActions.UPDATE_IS_CSR: {
      return {
        ...state,
        isCsr: action.payload,
      };
    }
    default:
      return state;
  }
}
